import React from 'react';
import { Ticket } from '../../SupportManagerType';
import { ArrowLeftOutlined } from '@ant-design/icons';

interface ViewTicketProps {
    ticket: Ticket;
    setViewingTicket: React.Dispatch<React.SetStateAction<Ticket | null>>;
}
const ViewTicketDetails: React.FC<ViewTicketProps> = ({ ticket, setViewingTicket }) => {

    return (
        <div className="ticket-details">
            <div className='ticket_info_title' onClick={() => setViewingTicket(null)}>
                <ArrowLeftOutlined /><span>Back</span>
            </div>
            <div className='ticket_common_box ticket_info_middle_box'>
                <div className='ticket_info_inner_box'><div className='ticket_label'>Ticket </div><span>-</span><p>{ticket.id}</p></div>
                <div className='ticket_info_inner_box'><div className='ticket_label'>Date </div><span>-</span><p>{ticket.date}</p></div>
                <div className='ticket_info_inner_box'><div className='ticket_label'>Status </div><span>-</span><p>{ticket.status}</p></div>
            </div>
            <div className='ticket_common_box ticket_info_message_box'>
                <p className='message_title'>Message</p>
                <p>{ticket.message}</p>
            </div>
        </div>
    );
}

export default ViewTicketDetails;
